import { render, staticRenderFns } from "./ExplainApp.vue?vue&type=template&id=58785536&"
import script from "./ExplainApp.vue?vue&type=script&lang=js&"
export * from "./ExplainApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports